<div [ngSwitch]="step">
  <div *ngSwitchCase="-1" class="fms-walk-me-presentation-modal">
    <ng-container *ngIf="!startTrial">
      <img class="fms-walk-me-presentation-logo" src="../../../assets/images/logo.png" alt="FlyMSG" />
      <h3>Hello {{ user.first_name }}!</h3>
      <h1>Welcome to FlyMSG</h1>
      <p>Let's explore and highlight what you need to know.</p>
      <button vng-button variant="accent" type="button" class="fms-walk-me-presentation-button" (click)="next()">
        Get Started
      </button>
    </ng-container>
    <ng-container *ngIf="startTrial">
      <div class="modal-overlay">
        <div class="trial-modal">
          <div class="modal-header"></div>

          <div class="modal-content">
            <h1 class="modal-title">We've Upgraded Your Account to Pro!</h1>
            <p class="modal-subtitle">
              Your 14-day trial is now active. For the next two weeks, use the Pro plan for free to write smarter, pitch
              better, and win more.
            </p>

            <p class="access-heading">Here's what you now have access to:</p>

            <div class="benefits-compact">
              <div class="benefit">
                <span class="benefit-icon">✅</span>
                <div class="benefit-content">
                  <span class="benefit-title">Unlimited AI Grammar Corrections</span>
                  <span class="benefit-description"
                    >Write with confidence, knowing every message you send is error-free anywhere online.</span
                  >
                </div>
              </div>
              <div class="benefit">
                <span class="benefit-icon">✍️</span>
                <div class="benefit-content">
                  <span class="benefit-title">Write with 7 different Personas or Voices</span>
                  <span class="benefit-description"
                    >Create different personas so we can write in your voice, tone or even industry on LinkedIn or via
                    our paragraph rewriter.</span
                  >
                </div>
              </div>
              <div class="benefit">
                <span class="benefit-icon">✨</span>
                <div class="benefit-content">
                  <span class="benefit-title">70 AI Prompts Per Day</span>
                  <span class="benefit-description"
                    >Instantly generate engaging comments and posts on LinkedIn or use FlyMSG to rewrite any sentence or
                    paragraph anywhere online.</span
                  >
                </div>
              </div>
              <div class="benefit">
                <span class="benefit-icon">⌨️</span>
                <div class="benefit-content">
                  <span class="benefit-title">Unlimited Text Expander</span>
                  <span class="benefit-description"
                    >Save hours by creating reusable message snippets for any scenario and get access to all 400+
                    FlyPlates (aka templates).</span
                  >
                </div>
              </div>
              <div class="benefit">
                <span class="benefit-icon">📚</span>
                <div class="benefit-content">
                  <span class="benefit-title">Unlimited Access to Sales Prospecting Training</span>
                  <span class="benefit-description"
                    >Access 15 hours of proven sales prospecting training covering LinkedIn, Video Selling, and Email
                    prospecting.</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              vng-button
              variant="accent"
              size="lg"
              fullWidth
              type="button"
              class="cta-button"
              (click)="next(); startTrialNow()"
            >
              Click Here To Get Started!
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngSwitchCase="0" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="0" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">Install the Extension</h4>
        <aside class="fms-walk-me-install-extension">
          <svg
            width="80"
            height="81"
            viewBox="0 0 80 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect y="0.5" width="80" height="80" fill="url(#pattern0_22542_15534)" />
            <defs>
              <pattern id="pattern0_22542_15534" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_22542_15534" transform="scale(0.0125)" />
              </pattern>
              <image
                id="image0_22542_15534"
                width="80"
                height="80"
                xlink:href="data:image/png;base64,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"
              />
            </defs>
          </svg>
          <h1>Welcome!</h1>
          <!-- Issue #537: single line — the <br> forced an artificial wrap; removed along with the p max-width below. -->
          <p>Download the extension to start using FlyMSG</p>

          <!-- Issue #518: folded in from the retired onboarding-0 wizard
               page (download-extension-step.component.html) — the
               pin-to-browser visual carries over onto this step instead of
               a separate page. -->
          <div class="fms-walk-me-install-extension-pin-hint">
            <img
              class="fms-walk-me-install-extension-pin-image"
              [attr.src]="'/assets/images/onboarding/step0-pin-' + pinAssetBrowserType + '.png'"
              alt="Pin FlyMSG to your browser toolbar"
            />
            <!-- Issue #537: single line — max-width removed below (was wrapping this). -->
            <p>After installing, pin FlyMSG to your toolbar so it's always one click away.</p>
          </div>
        </aside>
        <div
          class="fms-walk-me-right-panel-download-button"
          style="width: 155px"
          [ngClass]="{ 'fms-walk-me-button-highlight': !isInstalled }"
        >
          <button
              vng-button
              variant="accent"
              (click)="navigateToExtension()"
              type="button"
              data-fms-heap="walk-me-modal-more-download-extension"
            >
            <vng-icon name="download" color="inherit" [outline]="false" [size]="18"></vng-icon>
            Add to {{ extensionButtonBrowserName }}
          </button>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="1" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="1" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel fms-walk-me-about-you-panel">
        <h4 class="fms-walk-me-subtitle">About You</h4>
        <p>A couple quick questions to help us personalize FlyMSG for you.</p>
        <app-about-you-step [step]="step" [maxStep]="maxStep" (continueClicked)="next()"></app-about-you-step>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="2" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="2" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content fms-walk-me-step-3">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel fms-walk-me-signature-panel">
        <h4 class="fms-walk-me-subtitle">Add a FlyCut</h4>
        <p>Fill in your details below to build a signature FlyCut.</p>
        <app-add-flycut-signature-step (tryItOutClicked)="onSignatureTryItOut()"></app-add-flycut-signature-step>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="3" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="3" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content fms-walk-me-step-3">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">Test a FlyCut</h4>
        <p>Here is a video to help you learn how to use FlyCut.</p>
        <youtube-player
          #step3Video
          videoId="DYmhUVYxEig"
          (ready)="onPlayerReady($event, 3)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 3)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <button
            vng-button
            variant="ghost"
            (click)="tryFlyCutLater()"
            class="fms-walk-me-right-panel-skip-test-flycut-button"
            type="button"
            data-fms-heap="walk-me-modal-step-2-skip"
          >
            I'll try it later
          </button>
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 85px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 4 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="tryTestAFlyCut()"
              type="button"
              data-fms-heap="walk-me-modal-step-2-try-it-out"
            >
              Try it out!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="4" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="4" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content fms-walk-me-step-3">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">Add a FlyPlate</h4>
        <p>Here is a video to help you learn how to use FlyPlates.</p>
        <youtube-player
          #step4Video
          videoId="-ik0i_Vhucg"
          (ready)="onPlayerReady($event, 4)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 4)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <button
            vng-button
            variant="ghost"
            (click)="tryFlyCutLater()"
            class="fms-walk-me-right-panel-skip-test-flycut-button"
            type="button"
            data-fms-heap="walk-me-modal-step-3-skip"
          >
            I'll try it later
          </button>
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 85px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 5 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="tryAddAFlyPlate()"
              type="button"
              data-fms-heap="walk-me-modal-step-3-try-it-out"
            >
              Try it out!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="5" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="5" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">Create a Persona</h4>
        <p>
          Use Personas to help FlyMSG know who you are when writing for you. You'll define who we are speaking as when
          generating posts, comments, and more.
        </p>
        <youtube-player
          #step5Video
          videoId="CEEKMWOnVhg"
          (ready)="onPlayerReady($event, 5)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 5)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <button
            vng-button
            variant="ghost"
            (click)="tryPersonasLater()"
            class="fms-walk-me-right-panel-skip-test-flycut-button"
            type="button"
            data-fms-heap="walk-me-modal-step-4-skip"
          >
            Skip, I'll try later
          </button>
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 160px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 6 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="tryPersona()"
              type="button"
              data-fms-heap="walk-me-modal-step-4-try-it-out"
            >
              Try it out!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="6" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="6" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">LinkedIn AI Comment Generator</h4>
        <p>
          Here is a video to help you learn how to use FlyEngage on LinkedIn or Sales Navigator.
          <strong>Simply click “comment” on any post and watch the buttons come alive.</strong>
        </p>
        <youtube-player
          #step6Video
          videoId="KHw5HOZirM0"
          (ready)="onPlayerReady($event, 6)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 6)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <button
            vng-button
            variant="ghost"
            (click)="tryFlyEngageLater()"
            class="fms-walk-me-right-panel-skip-test-flycut-button"
            type="button"
            data-fms-heap="walk-me-modal-step-5-skip"
          >
            Skip, I don't use LinkedIn
          </button>
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 160px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 7 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="tryItOnLinkedIn()"
              type="button"
              data-fms-heap="walk-me-modal-step-5-try-it-out"
            >
              Try it out on LinkedIn!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="7" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="7" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">LinkedIn Social Post Generator</h4>
        <p>
          Here is a video to help you learn how to use FlyPosts on LinkedIn.
          <strong>Simply click “Start a Post” on your LinkedIn homepage and watch the buttons come alive.</strong>
        </p>
        <youtube-player
          #step7Video
          videoId="3ycEO-hPkZo"
          (ready)="onPlayerReady($event, 7)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 7)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <button
            vng-button
            variant="ghost"
            (click)="tryFlyPostLater()"
            class="fms-walk-me-right-panel-skip-test-flycut-button"
            type="button"
            data-fms-heap="walk-me-modal-step-6-skip"
          >
            Skip, I don't use Linkedin
          </button>
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 160px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 8 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="tryItOnLinkedIn()"
              type="button"
              data-fms-heap="walk-me-modal-step-6-try-it-out"
            >
              Try it out on LinkedIn!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="8" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="8" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content">
      <app-onboarding-checklist
        [activeStep]="step"
        (stepSelected)="setStep($event)"
        (moreLearningVideos)="navigateToMoreLearningVideos()"
      ></app-onboarding-checklist>
      <section class="fms-walk-me-right-panel">
        <h4 class="fms-walk-me-subtitle">FlyLearning</h4>
        <p>Here is a video to help you learn how to use FlyLearning</p>
        <youtube-player
          #step8Video
          [videoId]="'pWrEYH5f2Z0'"
          (ready)="onPlayerReady($event, 8)"
          [width]="360"
          [height]="203"
          (stateChange)="onStateChange($event, 8)"
        >
        </youtube-player>
        <div class="fms-walk-me-row fms-walk-me-right-panel-buttons">
          <div
            class="fms-walk-me-right-panel-download-button"
            style="width: 85px"
            [ngClass]="{ 'fms-walk-me-button-highlight': user.onboardingv2_step < 9 }"
          >
            <button
              vng-button
              variant="accent"
              (click)="goToFlyLearning()"
              type="button"
              data-fms-heap="walk-me-modal-step-6-try-it-out"
            >
              Try it out!
            </button>
          </div>
        </div>
      </section>
    </section>
  </div>

  <div *ngSwitchCase="9" class="fms-walk-me-presentation-modal">
    <app-walk-me-header [step]="9" (closeRequested)="close(true)"></app-walk-me-header>
    <section class="fms-walk-me-content fms-walk-me-step-9">
      <div style="width: 100%; height: 100%; padding: 10px">
        <p style="color: #2a1e36; font-size: 18px; font-weight: bold">
          Learn <span class="special-text">How to Navigate FlyMSG</span>
        </p>
        <p style="font-size: 14px; margin-bottom: 20px">
          Here are more learning videos to help you get more useful information about all the FlyMSG features.
        </p>

        <div style="position: relative">
          <div class="image-slider-outter-div">
            <div class="previous-btn-container">
              <button
                vng-icon-button
                color="none"
                type="button"
                class="previous-btn-div"
                aria-label="Previous videos"
                (click)="prevImageClick()"
              >
                <vng-icon name="chevron_left" [outline]="false"></vng-icon>
              </button>
            </div>
            <div class="fms-walk-me-video-carousels">
              <vng-carousel
                #nav1
                (slideClick)="playVideo1($event)"
                [infinite]="true"
                [slideSize]="{ width: '260px', height: '170px' }"
                [slides]="carouselSlides1"
                [showArrows]="false"
                style="cursor: pointer"
              >
              </vng-carousel>
              <vng-carousel
                #nav2
                (slideClick)="playVideo2($event)"
                [infinite]="true"
                [slideSize]="{ width: '260px', height: '170px' }"
                [slides]="carouselSlides2"
                [showArrows]="false"
                style="cursor: pointer"
              >
              </vng-carousel>
            </div>
            <div class="next-btn-container">
              <button
                vng-icon-button
                color="none"
                type="button"
                class="next-btn-div"
                aria-label="Next videos"
                (click)="nextImageClick()"
              >
                <vng-icon name="chevron_right" [outline]="false"></vng-icon>
              </button>
            </div>
          </div>
        </div>

        <button
          vng-button
          variant="ghost"
          type="button"
          class="fms-onboarding-additional-learning-back-button"
          (click)="backToOnboarding()"
        >
          Back to Onboarding Checklist
        </button>
      </div>
    </section>
  </div>
</div>
